import { forwardRef, lazy } from 'react';
import { useClientContext } from '../../context/client/ClientContext';
import { ClientType } from '../../context/client/types';
import type { HTMLContentProps } from './types';

export const importBlockEditorHTMLContent = () =>
  import(
    /* webpackChunkName: "block-editor-html" */
    './HtmlContent'
  );
const BlockEditorHTMLContent = lazy(importBlockEditorHTMLContent);

export const importHTMLContentVanilla = () =>
  import(
    /* webpackChunkName: "block-editor-html-vanilla" */
    './HTMLContentVanilla'
  );
const HTMLContentVanilla = lazy(importHTMLContentVanilla);

const HtmlContent = forwardRef<HTMLDivElement, HTMLContentProps>(function HtmlContent(props, ref) {
  const clientContext = useClientContext();

  // todo: apply this check only for salesforce, since in salesforce tiptap editor is not working due to getSelection api breaking
  if (clientContext?.client === ClientType.DeltaMatrix && clientContext.app === 'SALESFORCE') {
    return <HTMLContentVanilla {...props} ref={ref} />;
  }

  return <BlockEditorHTMLContent {...props} ref={ref} />;
});

export default HtmlContent;
